var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('h4',[_vm._v("菜单列表")]),_c('div',{staticStyle:{"padding-left":"30px"}},[_c('el-tree',{attrs:{"data":_vm.data,"props":_vm.defaultProps},on:{"node-click":_vm.handleNodeClick}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }